/**
 *
 * Asynchronously loads the component for ImportOrderPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
